import { createMessage } from "./utilities"

export const handleError = (error) => {
    if (error.response) {
        switch(error.response.status){
            case 401:
                return (error.response.data.message) ? createMessage(error.response.data.message, 'danger') 
                    : createMessage('Unauthorized. Try again later', 'danger')
            case 422:
                throw error;
            case 500:
                return createMessage('An internal error occurred, please contact system administrator');
            default:
                return createMessage('An error occurred, try again later', 'danger');
        }
    } else {
        return createMessage('An error occurred', 'danger');
    }
}